import React, { FC } from 'react';
import { MenuItem } from '@mui/material';
import { jobPayBySelectOptions } from '@efacity/common';
import { FormInputTextProps, FormTextInput } from './FormTextInput';

export const JobPostingPayBySelector: FC<FormInputTextProps> = ({ name, ...props }) => {
  return (
    <FormTextInput name={name} label="Job Pay By" select {...props}>
      {jobPayBySelectOptions.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </FormTextInput>
  );
};
